import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4931e566"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "success" }
const _hoisted_2 = { class: "success__header" }
const _hoisted_3 = { class: "success__description" }

import IconSuccess from "@/components/icons/IconSuccess.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressFormSuccess',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(IconSuccess, { class: "success__icon" }),
    _createElementVNode("p", _hoisted_2, [
      _renderSlot(_ctx.$slots, "header")
    ]),
    _createElementVNode("p", _hoisted_3, [
      _renderSlot(_ctx.$slots, "description")
    ])
  ]))
}
}

})